import styled from 'styled-components';

export const Card = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: Fixed (204px) px;
	height: 100%;
	padding: 14px;
	border-radius: 6px;
	border: 1px 0px 0px 0px;
	justify-content: space-between;
	opacity: 0px;
	border: 1px solid #dee2e6;

	& > *:not(:last-child) {
		margin-bottom: 0px;
	}

	& > *:last-child {
		margin-top: auto;
	}
`;

export const CardTitle = styled.div`
	font-size: 17.5px;
	font-weight: 500;
	line-height: 26px;
	text-align: left;
`;

export const CardSubtitle = styled.div`
	font-size: 11px;
	font-weight: 400;
	line-height: 18px;
	text-align: left;
	color: #6c757d;
`;

export const Completion = styled.div`
	font-size: 42px;
	font-weight: 500;
	line-height: 48px;
	text-align: left;
	container-type: inline-size;
`;

export const CompletionText = styled.div`
	font-size: 42px;
	line-height: 48px;
	font-size: clamp(24px, 20cqw, 50px); /* minimum 20px, based on 20.0cqw, maximum 50px */
	line-height: clamp(30px, 20cqw + 6px, 56px); /* minimum 30px, based on 20.0cqw + 6, maximum 56px */
`;
